import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./i18n/config";
import "./index.css";
import { applyStatusBarHeight, fixIOSWebViewHeight } from "./lib/utils";

// Apply status bar height on app start
applyStatusBarHeight();

// Fix iOS WebView height issue
fixIOSWebViewHeight();

// Register Service Worker for WASM caching
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((registration) => {
        console.log("[SW] Service Worker registered:", registration.scope);

        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // Check every hour

        // Warm the WASM cache so /scan doesn't pay the download cost on entry
        if ("caches" in window) {
          const wasmUrl = "https://assets.very.org/static/wasm/v1/PalmAPICapture.wasm";
          caches
            .open("very-wasm-cache-v1")
            .then((cache) =>
              cache.match(wasmUrl).then((hit) => {
                if (!hit) {
                  return cache.add(wasmUrl);
                }
              })
            )
            .catch((error) => {
              console.warn("[SW] WASM preload failed:", error);
            });
        }
      })
      .catch((error) => {
        console.warn("[SW] Service Worker registration failed:", error);
      });
  });
}

// Delay Sentry initialization (non-critical)
setTimeout(() => {
  import("@sentry/react").then((Sentry) => {
    Sentry.init({
      dsn: "https://2bf577dda3a7e22d022de7f5287958a3@errors.very.org/9",
      enabled: process.env.NODE_ENV !== "development",
    });
  });
}, 0);

createRoot(document.getElementById("root")!).render(<App />);
